<template>
  <div class="content">
    <promo-section></promo-section>

    <subscr-constructor-section></subscr-constructor-section>
  </div>
</template>



<script>
// @ is an alias to /src
import PromoSection from "@/views/home/partials/PromoSection.vue";
import SubscrConstructorSection from "@/views/home/partials/subscr-constructor_section/SubscrConstructorSection.vue";

export default {
  name: 'HomeView',
  components: {
    PromoSection,
    SubscrConstructorSection,
  }
}
</script>
